import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function NotFoundPage() {
  const { t } = useTranslation("dashboard");
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 px-4 text-center">
      <h1 className="text-brand-700 text-4xl font-bold">{t("notFound.title")}</h1>
      <p className="text-slate-600">{t("notFound.body")}</p>
      <Link to="/" className="text-brand-700 text-sm hover:underline">
        {t("notFound.back")}
      </Link>
    </main>
  );
}
